import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import { Flex } from 'pcln-design-system'
import NavLink from '../NavLink'
import { SmallNavDropdown } from '../SmallNavDropdown'
import SignedInNavLink from '../SignedInNavLink'
import SignOutNavLink from '../SignOutNavLink'
import useSSO from '../../hooks/useSSO'
import useLogout from '../../hooks/useLogout'
import { headerNavigationShape } from '../../utils/shapes'

const StyledNavLink = styled(NavLink)`
  padding: ${themeGet('space.3')};
  width: 100%;
`

function SmallNavigation({ color, iconColor, dropdownColor, navigation, target, ...props }) {
  const { handleSignOut, isSignedIn, membershipName, profile } = useSSO() || {}
  const { onLogoutClick } = useLogout()
  /* istanbul ignore next */
  const onSignOutClick = () => handleSignOut(onLogoutClick)

  return (
    <Flex flexDirection='column' pt='1px'>
      {isSignedIn && <SignedInNavLink membershipName={membershipName} profile={profile} />}
      {navigation &&
        navigation.length > 0 &&
        navigation.map((link) => {
          // eslint-disable-next-line no-unused-vars
          const { variation, ...linkProps } = link
          return link.links ? (
            <SmallNavDropdown
              {...link}
              key={`sm-dropdown-${link.label}`}
              color={color}
              iconColor={iconColor}
              backgroundColor={dropdownColor}
              target={target}
            />
          ) : (
            <StyledNavLink
              {...props}
              {...linkProps}
              key={`sm-navlink-${link.label}`}
              color={color}
              iconColor={iconColor}
              target={target}
            />
          )
        })}
      {isSignedIn && <SignOutNavLink color={color} onClick={onSignOutClick} />}
    </Flex>
  )
}

SmallNavigation.displayName = 'SmallNavigation'

SmallNavigation.propTypes = {
  color: PropTypes.string,
  iconColor: PropTypes.string,
  dropdownColor: PropTypes.string,
  navigation: PropTypes.arrayOf(headerNavigationShape),
  target: PropTypes.string,
}

export default memo(SmallNavigation)
